export enum OrderingEnum {
    ASC = 'ascend',
    DESC = 'descend'
}
